import Cookies from "js-cookie";
import { vm } from "../main.js";
import JsEncrypt from "jsencrypt";
import Base64 from "base-64";
import store from "../store";
// app 应用名
const app = "student_online_pc_";

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(`${app}${name}`, content);
};

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return;
  let item = window.localStorage.getItem(`${app}${name}`);
  try {
    item = JSON.parse(item);
  } catch (e) { }
  return item;
};

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(`${app}${name}`);
};

/**
 * 存储Cookies
 */
export const setCookies = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  Cookies.set(`${app}${name}`, content);
};

/**
 * 获取Cookies
 */
export function getCookies(name){
  if (!name) return;
  return Cookies.get(`${app}${name}`);
};

/**
 * 删除Cookies
 */
export const removeCookies = name => {
  if (!name) return;
  Cookies.remove(`${app}${name}`);
};

// 将记录设置到地址栏

export const setQuery = ({ name = "", params = {} }) => {
  if (
    vm.$route.name === name &&
    JSON.stringify(params) === JSON.stringify(vm.$route.query)
  ) {
    return;
  };
  let query = Object.assign({}, vm.$route.query, params);
  vm.$router.push({ name, query });
};

// 读取验证码倒计时

export const readCounter = option => {
  /**
   * option: { counterName, interval, time, counterObj }
   *
   *
   */
  // const obj = {}
  if (!getCookies(option.counterName)) return;
  const nowTimeStamp = new Date().getTime();
  const isOverTime =
    Math.floor((nowTimeStamp - getCookies(option.counterName)) / 1000) >= 60;
  let counter = isOverTime
    ? option.time
    : option.time -
    Math.floor((nowTimeStamp - getCookies(option.counterName)) / 1000);
  if (!isOverTime) {
    setCounter({
      counterName: option.counterName,
      interval: option.interval,
      time: counter,
      counterObj: option.counterObj,
      isNotOverTime: true
    });
  }
};
// 设置验证码倒计时
export const setCounter = option => {
  /**
   * option: { counterName, interval, time, counterObj, isOverTime }
   *
   *
   */
  let obj = {};
  let counter = option.time;
  let isNotOverTime = option.isNotOverTime || false;
  clearInterval(obj[option.counterName]);
  obj[option.counterName] = setInterval(() => {
    counter--;
    if (counter === 0) {
      clearInterval(obj[option.counterName]);
    }
    option.counterObj.counter = counter;
  }, option.interval);
  if (!isNotOverTime) {
    setCookies(option.counterName, new Date().getTime());
  }
};

// 本地时间
export const localTime = time => {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  return (time = String(year) + String(month) + String(strDate));
};

//获取当前时间，格式YYYY-MM-DD
export const getNowFormatDate = ({ type = "" }) => {
  let date = new Date();
  let seperator1 = "-";
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let strDate = date.getDate();

  let h = date.getHours(); //获取当前小时数(0-23)
  let m = date.getMinutes(); //获取当前分钟数(0-59)
  let s = date.getSeconds();

  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  const currentdate = year + seperator1 + month + seperator1 + strDate;
  const currentdateTime =
    year +
    seperator1 +
    month +
    seperator1 +
    strDate +
    " " +
    conver(h) +
    ":" +
    conver(m) +
    ":" +
    conver(s);
  return type === "datetime" ? currentdateTime : currentdate;
};
// 日期时间处理
function conver(s) {
  return s < 10 ? "0" + s : s;
}
/**
 * 寻找级联选择器路径new
 * @param { Object } arr   级联选择器 数组
 * @param { String/Number } value  用户修改后的对象
 * @param { String } key     寻址的字段
 * @return { Array } 返回对应的枚举寻址路径 址路径
 *
 */
export const findTreeRoad = (tree, value, key = "code") => {
  let road = [];
  if (!Array.isArray(tree)) return road;
  for (let i = 0; i < tree.length; i++) {
    if (tree[i][key] == value) {
      road.unshift(tree[i][key]);
      return road;
    }
    if (Array.isArray(tree[i].children) && tree[i].children.length) {
      road = findTreeRoad(tree[i].children, value, key);
      if (road.length > 0) {
        road.unshift(tree[i][key]);
        return road;
      }
    }
  }
  return road;
};

// 寻找树形结构的节点
export const getTreeNode = (tree, value, key = "id") => {
  if (!Array.isArray(tree) || !tree.length) return {};
  let node;
  for (let i = 0; i < tree.length; i++) {
    if (tree[i][key] == value) {
      node = tree[i];
      break;
    }
    if (Array.isArray(tree[i].children) && tree[i].children.length) {
      node = getTreeNode(tree[i].children, value, key);
      if (node) break;
    }
  }
  return node;
};

// 遍历树形结构
export function mapTreeData(tree, cb, children = "children") {
  if (Array.isArray(tree)) {
    tree.map(node => {
      if (node[children] && node[children].length > 0) {
        mapTreeData(node[children], cb, children);
      }
      cb(node);
    });
  }
}

// 过滤树状结构
export function filterTree(tree, value, key) {
  let arr = [...tree.filter(i => i[key] == value)]
  arr.forEach(i => {
    i.children = [...filterTree(i.children, value, key)]
  })
  return arr
}



// 组装成数组对象
export function assList(data, params = { code: "", value: "" }) {
  let obj = {}
  let arr = []
  Object.keys(params).forEach(e => {
    obj[e] = data[params[e]]
  });
  arr.push(obj)
  return arr
}

/**
 * 筛选当前页面按钮
 * @tree  { Object }  左侧菜单树
 * @path { String }    一级路由id
 * @spath { String }   二级路由id
 * @obj { Object }     当前页面按钮权限json
 */
export const PControl = (tree, code) => {
  if (!tree) return false

  // let obj = {}
  // tree.some(item => {
  //   if (item.code == code) {
  // 	item.children.some(item2 => {
  // 	  if (item2.code == codeChild) {
  // 		item2.children.forEach(item3 => {
  // 		  obj[item3.code] = true
  // 		})
  // 		return true
  // 	  }
  // 	})
  // 	return true
  //   }
  // })
  let obj = {}
  mapTreeData(tree, (item) => {
    if (item.pcode == code) {
      obj[item.code] = true
    }
  })
  return obj
}

// 扩展Date类：
export function Format(fmt) {
  var o = {
    "M+": this.getMonth() + 1,                 //月份
    "d+": this.getDate(),                    //日
    "h+": this.getHours(),                   //小时
    "H+": this.getHours(),                   //小时
    "m+": this.getMinutes(),                 //分
    "s+": this.getSeconds(),                 //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds()             //毫秒
  };
  // 年份
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ?
        (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

/**
 * 合并对象
 */
export const merge = function (obj1, obj2) {
  Object.keys(obj2).forEach(key => {
    obj1[key] = obj2[key]
  })
}

/**
 * 过滤对象的某些值
 */
export const filterKey = function (obj, arr) {
  let res = {}
  Object.keys(obj).forEach(key => {
    if (arr.indexOf(key) == -1) {
      res[key] = obj[key]
    }
  })
  return res
}
/**
 * 替换对象的Key值
 */
export const changeKey = function (obj, keys) {
  let res = {}
  Object.keys(obj).forEach(key => {
    if (keys.hasOwnProperty(key)) {
      res[keys[key]] = obj[key]
    } else {
      res[key] = res[key]
    }
  })
}

/**
 * 入参处理器
 */
export class paramsHandler {
  constructor(params) {
    this.params = deepClone(params)
  }

  filter(arr) {
    Object.keys(this.params).forEach(key => {
      if (arr.indexOf(key) != -1) {
        delete this.params[key]
      }
    })
    return this
  }

  changeKey(keys) {
    Object.keys(this.params).forEach(key => {
      if (keys.hasOwnProperty(key)) {
        this.params[keys[key]] = this.params[key]
        delete this.params[key]
      }
    })
    return this
  }

  get() {
    return this.params
  }
}


// 深拷贝
// 定义一个深拷贝函数  接收目标target参数
export const deepClone = (target) => {
  // 定义一个变量
  let result;
  // 如果当前需要深拷贝的是一个对象的话
  if (typeof target === 'object') {
    // 如果是一个数组的话
    if (Array.isArray(target)) {
      result = []; // 将result赋值为一个数组，并且执行遍历
      for (let i in target) {
        // 递归克隆数组中的每一项
        result.push(deepClone(target[i]))
      }
      // 判断如果当前的值是null的话；直接赋值为null
    } else if (target === null) {
      result = null;
      // 判断如果当前的值是一个RegExp对象的话，直接赋值
    } else if (target.constructor === RegExp) {
      result = target;
    } else {
      // 否则是普通对象，直接for in循环，递归赋值对象的所有值
      result = {};
      for (let i in target) {
        result[i] = deepClone(target[i]);
      }
    }
    // 如果不是对象的话，就是基本数据类型，那么直接赋值
  } else {
    result = target;
  }
  // 返回最终结果
  return result;
}

// 遍历树节点
export const treeMap = (obj, cb, children = 'children') => {
  function _treeMap(obj, cb) {
    if (typeof (obj) === 'object')
      Object.keys(obj).forEach(key => {
        cb(obj[key])
        if (obj[key][children]) {
          _treeMap(obj[key][children], cb)
        }
      })

  }
  _treeMap(obj, cb)
}

// 过滤不需要的key值
export const omit = (object, paths) => {
  var result = {}
  if (object == null) return result
  if (!Array.isArray(paths)) {
    paths = [paths]
  }
  Object.keys(object).forEach(key => {
    if (paths.indexOf(key) == -1) {
      result[key] = object[key]
    }
  })
  return result
}
// 获取需要的key值
export const pick = (object, paths) => {
  var result = {}
  if (object == null) return result
  if (!Array.isArray(paths)) {
    paths = [paths]
  }
  Object.keys(object).forEach(key => {
    if (paths.indexOf(key) > -1) {
      result[key] = object[key]
    }
  })
  return result
}

function getMonthDay(year, month) {
  let d = new Date(year, month, 0)
  return d.getDate()
}
export function getDateRange(time) {
  let [year, month, day] = time.split('-')
  if (day) {
    return [time, time]
  } else {
    return ([
      [year, month, '01'].join('-'),
      [year, month, getMonthDay(year, month)].join('-'),
    ])
  }

}

// 创建对象树
export function createObjTree(...rest) {
  function _map(tree, obj) {
    Object.keys(tree).forEach(key => {

      if (typeof (tree[key]) == 'string') {
        tree[key] = {
          ...obj
        }
      } else {
        _map(tree[key], obj)
      }
    })
  }
  let result = {}

  while (rest.length) {
    let arr = rest.shift()
    let obj = {}
    for (let key of arr) {
      obj[key] = ''
    }
    if (!Object.keys(result).length) {
      result = { ...obj }
    } else {
      _map(result, obj)
    }
  }
  return result
}


// 创建对象列表
export function createObjList(...rest) {
  let result = {}
  let queue = []

  while (rest.length) {
    let arr = rest.shift()
    if (queue.length == 0) {
      queue = queue.concat(arr)
      continue
    }
    let temp = []
    queue.forEach(v => {
      arr.forEach(i => {
        temp.push(v + i)
      })
    })
    queue = temp
  }

  queue.forEach(key => {
    result[key] = ''
  })
  return result
}

// 修建树形数据层级
export function getDeepTree(tree, maxDeep = 2, deep = 1) {
  if (!Array.isArray(tree)) return []
  let result = []
  tree.forEach(i => {
    if (deep < maxDeep) {
      i.children = getDeepTree(i.children, maxDeep, deep + 1)
    } else {
      i.children = null
    }
    result.push(i)
  })
  return result
}

// rsa加密
export function getRSApass (password) {
      let jse = new JsEncrypt()
      //公钥
      var publicString = `-----BEGIN PUBLIC KEY-----
              MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDwI1nQIS+4/YMzvm0g6rlE64t4
              15skTfwOWHXwksmaJb/wur/UrourhFADh6+Uq6XGEV1+SImfd5gnZ+0JIpMQipxk
              W7H8PEUUYxvzYV8EKWa3w+tSfd+MGqAly4OJESAP4zboS679N7uq0EZeD+rvQBcX
              Adfo+4iorCQTj8IKLwIDAQAB
              -----END PUBLIC KEY-----`;
      jse.setPublicKey(publicString)
      // 加密内容
      let encrypted = jse.encrypt(password)
      return encrypted
    }
// base64加密
export function getBase64 (e) {
      let res = Base64.encode(e);
      return res;
    }
  // base64编码
 export function base64encode (e) {
    let base64Content = Buffer.from(e).toString('base64');
    return base64Content;
  }
  // base64解码
  export function base64decode (e) {
    let commonContent = e.replace(/\s/g, '+');
    commonContent = Buffer.from(commonContent, 'base64').toString();
    return commonContent;
  }

// 生成随机字符串
export function generateUniqueString(length) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js